import {getLocalData, setLocalData} from "./StorageServices"

const _store = {
    state: {
        accessToken: getLocalData('accessToken', ''),
        refreshToken: getLocalData('refreshToken', ''),
        user: getLocalData('user', {}),
        timeExp: getLocalData('timeExp', ''),
    },
    subscribers: []
}

const _broadcast = () => {
    setTimeout(() => {
        _store.subscribers.forEach(subscriber => {
            subscriber(_store.state)
        })
    }, 0)
}

export const notifyUpdate = _broadcast

export const subscribe = subscriber => {
    if (typeof subscriber !== 'function') return
    if (_store.subscribers.indexOf(subscriber) !== -1) return

    _store.subscribers = [].concat(_store.subscribers, subscriber)
}

export const unsubscribe = subscriber => {
    _store.subscribers = _store.subscribers.filter(sub => sub !== subscriber)
}

export const isAuthenticated = () => {
    const {state} = _store

    return !!state.accessToken
}

export const setUserData = user => {
    const updatedUser = user

    _store.state = {
        ..._store.state,
        userRole: updatedUser
    }

    setLocalData('userRole', updatedUser)
    _broadcast()
}

export const getUserData = () => getLocalData('userRole') || _store.state.userRole || {}

export const setAccessToken = accessToken => {
    _store.state = {
        ..._store.state,
        accessToken,
    }

    setLocalData('accessToken', accessToken)
}

export const setRefreshToken = refreshToken => {
    _store.state = {
        ..._store.state,
        refreshToken,
    }

    setLocalData('refreshToken', refreshToken)
}

export const setTimeExp = timeExp => {
    _store.state = {
        ..._store.state,
        timeExp,
    }

    setLocalData('timeExp', timeExp)
}

export const getAccessToken = () => getLocalData('accessToken') || _store.state.accessToken || ''

export const getRefreshToken = () => getLocalData('refreshToken') || _store.state.refreshToken || ''

export const getTimeExp = () => getLocalData('timeExp') || _store.state.timeExp || ''

export const logoutUser = (message = '') => {

    setAccessToken('')
    setRefreshToken('')
    setUserData({})
    _broadcast()

    return true
}
